import { MODERNIZED_BLOCK_DIAGRAM_FONT as FONT } from './consts';
import { canvasLabelMeasurer } from './canvasLabelMeasurer';

type MeasurableFont = {
  fontWeight: string;
  fontSize: number;
  fontFamily: string;
};

export const createMeasurerFromFont = (font: MeasurableFont) => {
  const fontString = `${font.fontWeight} ${font.fontSize}px ${font.fontFamily}`;
  return canvasLabelMeasurer(fontString);
};

const measureNodeLabel = canvasLabelMeasurer(FONT);

export { measureNodeLabel };
